import React, { FC, ReactElement } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../../redux/rootReducer';
import { getADATitle } from '../../util/Ada';
import { fullDateFormat } from '../../util/date';
import { LOC } from '../../util/strings';
import ParseHtml from '../common/ParseHtml';
import withLocalization from '../hoc/withLocalization';
import PackagePrice from '../OfferEligibility/PackagePriceInformation/PackagePrice';
import './PackageSummaryReview.scss';

const PackageSummaryReview: FC<any> = (props: any): ReactElement => {
  const { localize } = props;
  const offerDetails = useSelector((state: RootState) => state.offerDetails);
  const selectedRoom = offerDetails.selectedRoomType;
  const availabilityDates = useSelector((state: RootState) => state.availabilityDates);
  const selectedDate = availabilityDates.finalSelectedDate;
  const offer = offerDetails.currentOffer;
  const searchParameter = offerDetails.searchParameter;
  const openDateSelector = availabilityDates.openDateSelector;
  const hearingADACode = availabilityDates.hearingADACode;
  const selectedADARoomCode = availabilityDates?.roomADACode ? availabilityDates.roomADACode : '';
  const extraNights = availabilityDates.finalSelectedExtraNights ? availabilityDates.finalSelectedExtraNights : 0;
  const numberofNights = selectedRoom && selectedRoom.numberOfNights ? parseInt(selectedRoom.numberOfNights, 10) : 0;
  const alternateLOCDescription = offerDetails.alternateLOCDescription;

  const premiums =
    offer && offer.premiums
      ? offer?.premiums
          .filter((x) => x !== null)
          .join(', ')
          .trim()
      : '';
  return (
    <div>
      <div className="packageSummaryReviewDisplay">
        <h5 className="confirmationHeader">
          {localize('preview-sales-engine.static-content.copy.package-summary-component.title')}
        </h5>
        <div className="headingPadding">
          <table className="package-summary-table">
            <tbody>
              {searchParameter.mode === LOC ? (
                <tr>
                  <td className="bolderText">
                    {localize('preview-sales-engine.static-content.copy.package-summary-component.package-code-label')}{' '}
                  </td>
                  <td className="">{offerDetails?.locDescription}</td>
                </tr>
              ) : (
                <tr>
                  <td className="bolderText">
                    {localize('preview-sales-engine.static-content.copy.package-summary-component.pin-label')}{' '}
                  </td>
                  <td className="">{searchParameter.pin}</td>
                </tr>
              )}
              {alternateLOCDescription ? (
                <tr>
                  <td className="bolderText">
                    {localize('preview-sales-engine.static-content.copy.Labels.labels#alternate-loc')}:
                  </td>
                  <td>{alternateLOCDescription}</td>
                </tr>
              ) : (
                <></>
              )}
              <tr className="bolderText upperCase ">
                <td className="paddingTop">
                  {' '}
                  {localize(
                    'preview-sales-engine.static-content.copy.package-summary-component.package-details-header',
                  )}
                </td>
              </tr>
              <tr>
                <td className="bolderText">
                  {localize('preview-sales-engine.static-content.copy.package-summary-component.resort-label')}
                </td>
                <td>{selectedRoom?.property?.name}</td>
              </tr>
              {!openDateSelector && selectedDate && selectedDate.checkInDate ? (
                <tr>
                  <td className="bolderText">
                    {localize('preview-sales-engine.static-content.copy.package-summary-component.check-in-label')}
                  </td>
                  <td> {fullDateFormat(selectedDate.checkInDate)}</td>
                </tr>
              ) : (
                <></>
              )}

              {!openDateSelector && selectedDate && selectedDate.checkOutDate ? (
                <tr>
                  <td className="bolderText">
                    {localize('preview-sales-engine.static-content.copy.package-summary-component.check-out-label')}
                  </td>
                  <td>{fullDateFormat(selectedDate.checkOutDate)}</td>
                </tr>
              ) : (
                <></>
              )}
              <tr>
                <td className="bolderText">
                  {localize('preview-sales-engine.static-content.copy.package-summary-component.unit-type-label')}{' '}
                </td>
                <td>{selectedRoom?.roomTypeDescription}</td>
              </tr>

              <tr>
                <td className="bolderText">
                  {localize('preview-sales-engine.static-content.copy.package-summary-component.nights-label')}{' '}
                </td>
                <td>{numberofNights}</td>
              </tr>
              {!openDateSelector && extraNights > 0 ? (
                <tr>
                  <td className="bolderText">
                    {localize('preview-sales-engine.static-content.copy.Labels.labels#extra-nights')}
                  </td>
                  <td>{extraNights}</td>
                </tr>
              ) : (
                <></>
              )}
              <tr>
                <td className="bolderText">
                  {localize('preview-sales-engine.static-content.copy.Confirmation Page.max-guests')}
                </td>
                <td>{selectedRoom?.sleepCapacity}</td>
              </tr>

              {(selectedADARoomCode || hearingADACode) && !openDateSelector ? (
                <tr>
                  <td className="bolderText">
                    {localize(
                      'preview-sales-engine.static-content.copy.package-summary-component.accessibility-selections',
                    )}{' '}
                  </td>
                  <td>
                    {selectedADARoomCode ? localize(getADATitle(selectedADARoomCode)) : ''}
                    {hearingADACode && selectedADARoomCode ? ', ' : ''}
                    {hearingADACode ? localize('preview-sales-engine.static-content.copy.ADA.hearing') : ''}
                  </td>
                </tr>
              ) : (
                <></>
              )}
              {premiums && (
                <tr>
                  <td className="bolderText paddingTop">
                    {localize('preview-sales-engine.static-content.copy.package-summary-component.tour-gift-label')}{' '}
                  </td>
                  <td>
                    <ParseHtml
                      htmlInput={`${localize(
                        'preview-sales-engine.static-content.copy.prospects.plustext',
                      )} ${premiums}`}
                    ></ParseHtml>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
          <div className="priceWrapper">
            <PackagePrice />
          </div>
        </div>
      </div>
    </div>
  );
};

export default withLocalization(PackageSummaryReview);
